import { axios } from '@/services/axios';

const getSSOProvider = async (providerId) => {
    const res = await axios.get(`/sso/provider/${providerId}`);
    return res.data;
};

export default getSSOProvider;
